import React from 'react';
import {
  
  InputControl,
  
} from "formik-chakra-ui";

function InputTextLogin(props) {
	const {name,type,inputValue,title} = props
	const [value, setValue] = React.useState('')
	const handleChange = (event) => setValue(event.target.value)
	return(
		<>
			<div className="field_section">
					
				 <InputControl name={name} inputProps={props.inputProps} type={type} label={title} />
				
			</div>
			
		</>
	);
}

export default InputTextLogin;